<app-header [style]="'white'"></app-header>

<div class="section-wrapper" id="newsroom">
  <div class="container">
    <div class="mini-title">{{ "NEWS.NEWSROOM" | translate }}</div>
    <div class="news-header">
      <h1 class="title component-title">
        {{ "NEWS.ANNOUNCEMENT" | translate }}
      </h1>
    </div>
    <div class="news-list highlighted">
      <div class="news-item" *ngFor="let item of highlightNewsList">
        <div class="">
          <div class="date">{{ item.created_at | date : "dd" }}</div>
          <div class="month-year">
            {{ item.created_at | date : "MMM YYYY" }}
          </div>
        </div>
        <div class="">
          <h2
            *ngIf="currentLang == 'en'"
            class="item-title"
            innerHTML="{{ item.parsed_title.en }}"
          ></h2>
          <h2
            *ngIf="currentLang != 'en'"
            class="item-title"
            innerHTML="{{ item.parsed_title.id }}"
          ></h2>
          <a
            href="{{ 'news/' + item.slug }}"
            class="mini-title read-more"
            target="_blank"
            >CONTINUE READING</a
          >
          <!-- <a href="{{ item.url }}" class="mini-title share">SHARE</a> -->
        </div>
      </div>
    </div>

    <div class="news-list">
      <div class="news-item" *ngFor="let item of newsList">
        <div class="row">
          <div class="col-md-2">
            <div class="date">{{ item.created_at | date : "dd" }}</div>
            <div class="month-year">
              {{ item.created_at | date : "MMM YYYY" }}
            </div>
          </div>
          <div class="col-md-10">
            <div
              *ngIf="currentLang == 'en'"
              class="item-title"
              innerHTML="{{ item.parsed_title.en }}"
            ></div>
            <div
              *ngIf="currentLang != 'en'"
              class="item-title"
              innerHTML="{{ item.parsed_title.id }}"
            ></div>

            <!-- <div class="item-title">{{ item.parsed_title.en }}</div> -->
            <a
              href="{{ 'news/' + item.slug }}"
              class="mini-title read-more"
              target="_blank"
              >CONTINUE READING</a
            >
            <!-- <a href="{{ item.url }}" class="mini-title share">SHARE</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <pagination
        *ngIf="totalItems > 0"
        [totalItems]="totalItems"
        [directionLinks]="false"
        [itemsPerPage]="itemsPerPage"
        (pageChanged)="pageChanged($event)"
      >
      </pagination>
    </div>
  </div>
</div>

<app-footer></app-footer>
